import React, { useCallback, useState } from 'react';
import FormActionButtons from 'components/ui/form-action-buttons';
import { SubmissionTabProps } from 'routes/Submissions/SubmissionDetail/navigation-tab/submission-config-tabs';
import PerilSettingsTable from './components/peril-settings-table';
import SubLimitsTable from './components/sub-limits-table';

const SubLimitsConfiguration: React.FC<SubmissionTabProps> = ({
  submission,
  includeBack,
  includeNext,
  navigateBack,
  navigateNext,
}) => {
  const subLimitsTableRef = React.useRef<{ save: Promise<void> }>(null);
  const [isNextDisabled, setIsNextDisabled] = useState(false);

  const handleNext = useCallback(async () => {
    setIsNextDisabled(true);
    await subLimitsTableRef.current?.save;
    navigateNext();
  }, [navigateNext, subLimitsTableRef]);

  return (
    <>
      <PerilSettingsTable submission={submission} />

      <SubLimitsTable
        submission={submission}
        onErrorChange={setIsNextDisabled}
      />

      <FormActionButtons
        confirmText="Next"
        cancelText="Back"
        isConfirmDisabled={isNextDisabled}
        includeCancel={includeBack}
        includeConfirm={includeNext}
        confirmOutlined={false}
        onCancel={navigateBack}
        onConfirm={handleNext}
      />
    </>
  );
};

export default SubLimitsConfiguration;
